<p>overflowing-time-block-month-view-dialog works!</p>
